import React from 'react';
import { IonApp } from '@ionic/react';
import { useCapacitorPlatform } from '@shared/hooks/useCapacitorPlatform';
import { useFeatureFlags } from '@shared/flags/FeatureFlagProvider';

export interface IonicShellProps {
  children: React.ReactNode;
}

/**
 * Native Capacitor builds always mount IonApp.
 *
 * Pro/Citizen first screens (e.g. /pro/login) use IonPage/IonContent, which
 * collapse to ~0 height without an IonApp ancestor — a solid white screen.
 * Gating IonApp behind LaunchDarkly `ionic_enabled` made that a production
 * outage whenever LD was slow, offline, or defaulted false for anonymous
 * App Review installs. Keep the flag for gradual *web* Ionic rollout only.
 */
const IonicShell: React.FC<IonicShellProps> = ({ children }) => {
  const { flags } = useFeatureFlags();
  const { isNative } = useCapacitorPlatform();
  const forceWebLayout = import.meta.env.VITE_IONIC_WEB_LAYOUT === '1';
  const shouldWrap = isNative || (flags.ionic_enabled && forceWebLayout);

  if (!shouldWrap) {
    return <>{children}</>;
  }

  return <IonApp>{children}</IonApp>;
};

export default IonicShell;
